import DirectDebitBecsMandate from './direct-debit-becs-mandate';

export default DirectDebitBecsMandate;
